'use strict';

// @flow

var ChatUtils = {

  createRoom: function createRoom(updates, timestamp, room, //: { id: string, title: string, type: string }
  team //: { id: string }
  ) {
    if (!room.type) {
      room.type = 'group';
    }

    updates['rooms/' + room.id + '/metadata/'] = {
      id: room.id,
      type: room.type,
      title: room.title,
      color: '#059588',
      teamId: team && team.id,
      creationTimestamp: timestamp
    };

    // Option teamInfo
    if (team && team.id) {
      updates['teams/' + team.id + '/rooms/' + room.id] = {
        roomId: room.id,
        type: room.type
      };
    }
    return updates;
  },

  addUsersToRoom: function addUsersToRoom(updates, timestamp, room, //: { id: string },
  team, //: { id: string },
  members //: Array<{ userId: string, displayName: string, access: string }>
  ) {
    members.forEach(function (member) {
      updates['rooms/' + room.id + '/members/' + member.userId] = member;
      updates['users/' + member.userId + '/rooms/' + team.id + '/' + room.id] = {
        lastActTimestamp: timestamp,
        lastUserActTimestamp: 0,
        "title": room.title !== undefined ? room.title : '',
        "type": room.type ? room.type : 'group',
        "color": "#059588",
        "avatarMembers": {/* Will be computed by firebase cloud function */}
      };
    });

    // To recompute the avatarMembers & the final title of each member of this room
    updates['queue/userRooms/' + room.id] = timestamp;

    return updates;
  },

  removeUserFromRoom: function removeUserFromRoom(updates, timestamp, room, // : { id: string },
  team, //: { id: string },
  member // : { userId: string }
  ) {
    updates['rooms/' + room.id + '/members/' + member.userId + '/delete'] = true;
    updates['users/' + member.userId + '/rooms/' + team.id + '/' + room.id + '/delete'] = true;

    // To recompute the avatarMembers & the final title of each member of this room
    updates['queue/userRooms/' + room.id] = timestamp;

    return updates;
  },

  sendTextMessage: function sendTextMessage(updates, timestamp, room, //: { id: string },
  sender, //: { id: string, displayName: string },
  message //: { id: string, text: string, muted: boolean }
  ) {
    if (typeof message.muted !== 'boolean') {
      message.muted = false;
    }

    updates['rooms/' + room.id + '/messages/' + message.id] = {
      senderId: sender.id,
      senderName: sender.displayName,
      metadata: {
        type: 'text',
        text: message.text
      },
      muted: message.muted,
      timestamp: timestamp,
      status: 'sent'
    };
    return updates;
  },

  createTitleFromMembers: function createTitleFromMembers(otherMembers, thisUser) {
    var membersTransformed = otherMembers.map(function (member) {
      return member.displayName;
    });
    if (membersTransformed.length === 0) {
      membersTransformed.push(thisUser.displayName);
    }
    return membersTransformed.join(", ");
  },

  computeUserRooms: function computeUserRooms(updates, roomId, roomMetadata, roomMembers, teamMembers) {
    // Get the color & displayName of every active member of this room
    // and sort it by key
    var teamMembersArray = Object.keys(roomMembers).sort().filter(function (key) {
      return !roomMembers[key].delete;
    }).map(function (key) {
      return {
        id: key,
        color: teamMembers[key].color,
        displayName: teamMembers[key].displayName
      };
    });

    // Foreach member of the room compute userRoom information

    var _loop = function _loop(workerId) {
      // No need to update deleted members
      if (roomMembers[workerId].delete) {
        return 'continue';
      }

      // Get the first 4 members of the room without this user
      var otherMembers = teamMembersArray.filter(function (obj) {
        return obj.id !== workerId;
      });
      var avatarMembers = otherMembers.slice(0, 4);

      // It is just this user
      if (avatarMembers.length === 0) {
        avatarMembers.push({
          id: workerId,
          color: teamMembers[workerId].color,
          displayName: teamMembers[workerId].displayName
        });
      }

      // Use the title from the room or create a new title using the list of members
      var title = roomMetadata.title ? roomMetadata.title : ChatUtils.createTitleFromMembers(otherMembers, {
        displayName: teamMembers[workerId].displayName
      });

      var prefixPath = 'users/' + workerId + '/rooms/' + roomMetadata.teamId + '/' + roomId + '/';
      updates[prefixPath + 'title'] = title;
      updates[prefixPath + 'avatarMembers'] = avatarMembers;
      updates[prefixPath + 'type'] = roomMetadata.type ? roomMetadata.type : 'group';
      updates[prefixPath + 'color'] = roomMetadata.color ? roomMetadata.color : '#059588';
    };

    for (var workerId in roomMembers) {
      var _ret = _loop(workerId);

      if (_ret === 'continue') continue;
    }

    return updates;
  }
};

module.exports = ChatUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/ChatUtils.js
// module id = 115
// module chunks = 0